const a11yColorAttribute = 'a11yColor';
const a11yToggleDisableAttribute = 'a11yDisableToggle';
const accessibleColorsClass = 'accessible-colors';
class AccessibilityToggle extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			inputs: document.querySelectorAll('.accessibility-toggle__checkbox'),
			inputColor: document.querySelector('#checkbox_colors'),
			toggle: this.querySelector('.accessibility-toggle__btn'),
			toggleDisable: document.querySelector('.accessibility-toggle__disable'),
			toggleHide: this.querySelector('.accessibility-toggle__hide'),
			documentTag: document.documentElement,
			documentBody: document.body,
			reset: document.querySelector('.accessibility-toggle__reset'),
			skio: document.querySelector('skio-plan-picker'),
		};
		this.a11yColorsLocalStorage = window.localStorage.getItem(a11yColorAttribute) ?? null;
		this.a11yDisableLocalStorage = window.localStorage.getItem(a11yToggleDisableAttribute) ?? null;
		this.addListeners();
		this.changedElements = [];

		const windowStyle = window.getComputedStyle(document.body);
		this.rgbPrimaryColor = hexToRgb(windowStyle.getPropertyValue('--color-primary'));
		this.rgbSecondaryColor = hexToRgb(windowStyle.getPropertyValue('--color-secondary'));
	}
	addListeners() {
		const { inputs, toggle, reset, inputColor, toggleDisable, toggleHide } = this.elements;
		if (this.a11yDisableLocalStorage == 'true') {
			this.classList.add('hidden');
			return;
		}

		if (this.a11yColorsLocalStorage == 'true') {
			setTimeout(() => {
				inputColor.click();
			}, 0);
		}
		toggleDisable.addEventListener('click', this.disableAccessibilityButton.bind(this));
		toggleHide.addEventListener('click', this.disableAccessibilityButton.bind(this));
		toggle.addEventListener('click', this.open.bind(this));
		inputs.forEach((input) => {
			input.addEventListener('change', this.toggleAccessibility.bind(this, input));
		});
		reset.addEventListener('click', this.resetToggles.bind(this));
	}
	addAccessibleColorsToggle() {
		const { documentBody } = this.elements;
		const elementsOnPage = document.querySelectorAll('body *');

		this.addSkioA11yClassesToElements();

		elementsOnPage.forEach((el) => {
			this.addAccessibilityClassToElement(el);
		});

		documentBody.classList.add(accessibleColorsClass);
		window.localStorage.setItem(a11yColorAttribute, 'true');
	}

	addAccessibilityClassToElement(el) {
		const bgColor = window.getComputedStyle(el, null)?.getPropertyValue('background-color');
		const borderColor = window.getComputedStyle(el, null)?.getPropertyValue('border-color');
		const color = window.getComputedStyle(el, null)?.getPropertyValue('color');

		if (this.rgbPrimaryColor == bgColor) {
			el.classList.add('accessible-color-element__primary-bg');
			this.changedElements.push(el);
		} else if (this.rgbSecondaryColor == bgColor) {
			el.classList.add('accessible-color-element__secondary-bg');
			this.changedElements.push(el);
		}

		if (this.rgbPrimaryColor == color) {
			el.classList.add('accessible-color-element__primary-text');
			this.changedElements.push(el);
		} else if (this.rgbSecondaryColor == color) {
			el.classList.add('accessible-color-element__secondary-text');
			this.changedElements.push(el);
		}

		if (this.rgbPrimaryColor == borderColor) {
			el.classList.add('accessible-color-element__primary-border');
			this.changedElements.push(el);
		} else if (this.rgbSecondaryColor == borderColor) {
			el.classList.add('accessible-color-element__secondary-border');
			this.changedElements.push(el);
		}
	}

	addSkioA11yClassesToElements() {
		const { skio } = this.elements;
		setTimeout(() => {
			const skioPlanPicker = skio.shadowRoot.querySelector('.skio-plan-picker');
			skioPlanPicker.classList.add('skio-accessible-colors');
		}, 0);
	}
	disableAccessibilityButton() {
		window.localStorage.setItem(a11yToggleDisableAttribute, 'true');
		this.classList.add('hidden');
	}
	open() {
		this.classList.toggle('accessibility-toggle--active');
	}
	removeAccessibleColorsToggle() {
		const { documentBody } = this.elements;

		this.removeSkioA11yClassesToElements();

		this.changedElements.forEach((el) => {
			el.classList.remove('accessible-color-element__primary-bg');
			el.classList.remove('accessible-color-element__secondary-bg');
			el.classList.remove('accessible-color-element__primary-text');
			el.classList.remove('accessible-color-element__secondary-text');
			el.classList.remove('accessible-color-element__primary-border');
			el.classList.remove('accessible-color-element__secondary-border');
		});

		this.changedElements = [];

		documentBody.classList.remove(accessibleColorsClass);
		window.localStorage.setItem(a11yColorAttribute, 'false');
	}
	removeSkioA11yClassesToElements() {
		const { skio } = this.elements;
		setTimeout(() => {
			const skioPlanPicker = skio.shadowRoot.querySelector('.skio-plan-picker');
			skioPlanPicker.classList.remove('skio-accessible-colors');
		}, 0);
	}
	resetToggles() {
		const { inputs } = this.elements;

		// input.click() instead of input.checked = false
		// to activate input change event listener
		inputs.forEach((input) => {
			if (input.checked) {
				input.click();
			}
		});
	}
	toggleAccessibility(input) {
		if (input.checked) {
			this.addAccessibleColorsToggle();
		} else {
			this.removeAccessibleColorsToggle();
		}
	}
}
customElements.define('accessibility-toggle', AccessibilityToggle);
